import { forwardRef } from "react";
import { styled } from "@mui/material/styles";
import { Button, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";

const Separator = styled("div")(
  ({ theme }) => `
  height: ${theme.spacing(3)};
`
);

const CustomSlider = withStyles({
  markLabel: {
    fontSize: "11px",
  },
  valueLabel: {
    fontSize: "9px",
    whiteSpace: "normal",
  },
})(Slider);

const NonLinearQuestion = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      handlePayload,
      nonLinearValue,
      latestStepQuestion,
      isEdit,
      payload,
      steps,
      handelRequiredQuestion,
      requiredQuestion
    },
    ref
  ) => {
    const scale = (value) => {
      const previousMarkIndex = Math.floor(value / data.step);
      
      if (previousMarkIndex >= 0 && previousMarkIndex < data.marks.length) {
        const previousMark = data.marks[previousMarkIndex];
        return previousMark ? previousMark.scaledValue : 0;  
      }
      return 0;  
    };
    
    const descale = (scaledValue) => {
      if (scaledValue !== undefined) {
        const mark = data.marks.find((el) => el.scaledValue === scaledValue);
        return mark ? mark.value : 0;  
      } else {
        return data?.nullStart ? 0 : 1;  
      }
    };
    
    const isMobile = useMediaQuery("(max-width:900px)");

    const nextQuestionHandler = (height) => {
      if (steps[0] === 2 && payload["externalised_HR_service_B"] === null) {
        handelRequiredQuestion(true)
      } else {
        handlePayload(data, nonLinearValue);
        scrollToQuestion(data, height, nonLinearValue);
      }
    };

    const handleSliderChange = (event, newValue) => {
      // setValue(newValue);
      handlePayload(data, scale(newValue));
    };
    const { t } = useTranslation();

    const valuetext = (value) => {
      switch (value) {
        case 0:
          return t("less_than_90");
        case 10:
          return t("up_to_36.5");
        case 20:
          return t("up_to_3.65");
        case 30:
          return t("up_to_8.76");
        case 40:
          return t("up_to_52.56");
        case 50:
          return t("up_to_5.26");
        default:
          return "";
      }
    };

    return (
      <div style={{ padding: isMobile ? "100px 0px" : "100px 20px" }} ref={ref}>
        <>
          <Typography variant="subtitle1">{t(data.question)}</Typography>
          <br></br>
          {isMobile ? (
            <Box>
              <CustomSlider
                // track={false}
                value={descale(nonLinearValue)}
                // getAriaValueText={valuetext}
                min={data.min}
                step={data.step}
                max={data.max}
                valueLabelDisplay={data.valueLabelDisplay}
                valueLabelFormat={valuetext}
                marks={data.marks}
                defaultValue={0}
                // scale={scale}
                onChange={handleSliderChange}
                aria-labelledby="non-linear-slider"
              />
              <Separator />
            </Box>
          ) : (
            <Box>
              <Slider
                // track={false}
                value={descale(nonLinearValue)}
                // getAriaValueText={valuetext}
                min={data.min}
                step={data.step}
                max={data.max}
                valueLabelDisplay={data.valueLabelDisplay}
                valueLabelFormat={valuetext}
                marks={data.marks}
                defaultValue={0}
                // scale={scale}
                onChange={handleSliderChange}
                aria-labelledby="non-linear-slider"
              />
              <Separator />
            </Box>
          )}

          {(payload[data?.key] === 0 ? false : !payload[data?.key]) && (
            <span style={{fontSize: "18px"  }} className="error-message-autocomplete">
              {t("required_field")}
            </span>
          )}
          {currentQuestion === data.id &&
            currentQuestion !== latestQuestion &&
            !(isEdit && latestStepQuestion === data.id) ? (
            <>
              {" "}
              {/* <br></br> */}
              <Button
                onClick={() => {
                  nextQuestionHandler(ref.current.clientHeight);
                }}
                disabled={payload[data?.key] === 0 ? false : !payload[data?.key]}
                style={{ height: "50px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <></>
          )}
          {requiredQuestion && (
            <span className="error-message-radio">
              {t("required_question")}: {t("is_your_hr_activity_oursourced")}
            </span>
          )}
        </>
      </div>
    );
  }
);

export default NonLinearQuestion;
